import type { CognitoConfig } from '../app/core/authentication/cognito-config';

export const environment = {
  name: 'DEV',
  production: false,
  apiUrl: 'https://api.dev.prenomina.htaflow.com',
  cognito: {
    region: 'us-west-2',
    userPoolId: 'us-west-2_2QIICdAEh',
    clientId: '5t9jmadfq2sqo2rn814dvc0l41',
  } satisfies CognitoConfig,
} as const;